export const EMPLOYEE_ROLES = [
  'ceo',
  'cto',
  'compliance_head',
  'compliance_officer',
  'finance_manager',
  'accountant',
  'support_lead',
  'support_operator',
] as const;

export type EmployeeRole = (typeof EMPLOYEE_ROLES)[number];

export const ASSIGNABLE_EMPLOYEE_ROLES = [
  'cto',
  'compliance_head',
  'compliance_officer',
  'finance_manager',
  'accountant',
  'support_lead',
  'support_operator',
] as const;

export type AssignableEmployeeRole = (typeof ASSIGNABLE_EMPLOYEE_ROLES)[number];

export function isEmployeeRole(v: string): v is EmployeeRole {
  return (EMPLOYEE_ROLES as readonly string[]).includes(v);
}

export function isAssignableEmployeeRole(v: string): v is AssignableEmployeeRole {
  return (ASSIGNABLE_EMPLOYEE_ROLES as readonly string[]).includes(v);
}

export type JwtPayload = {
  sub: string;
  email: string;
  role: EmployeeRole;
  iat?: number;
  exp?: number;
};

export type Employee = {
  id: string;
  name: string;
  email: string;
  role: EmployeeRole;
  created_at?: string;
};

export type LoginResponse = {
  ok: boolean;
  token: string;
  employee: Employee;
  error?: string;
};

export type EmployeesListResponse = {
  ok: boolean;
  employees: Employee[];
  error?: string;
};

export type CreateEmployeeResponse = {
  ok: boolean;
  employee: Employee;
  error?: string;
};

export type EmployeeMutationResponse = {
  ok: boolean;
  employee?: Employee;
  error?: string;
};
